import React from 'react';
import SubfolderSlider from '../SubfolderSlider';
import { compose } from 'redux';
import withCurrentGallectionSubfolders, {
  WithCurrentGallectionSubfoldersProps,
} from '../../_hocs/withCurrentGallectionSubfolders';
import withCurrentSubfolder, {
  WithCurrentSubfolderProps,
} from '../../_hocs/withCurrentSubfolder';
import FolderCard from '../../../FolderCard';

export interface Props {}

const enhance = compose(
  withCurrentGallectionSubfolders,
  withCurrentSubfolder as any
) as any;

export const SelectableSubfolderSlider: React.FC<
  Props & WithCurrentGallectionSubfoldersProps & WithCurrentSubfolderProps
> = ({ subfolders, currentSubfolderId, setCurrentSubfolderId }) => {
  if (!subfolders.length) {
    return null;
  }
  return (
    <SubfolderSlider>
      {subfolders.map((subfolder, index) => (
        <FolderCard
          width={128}
          isSelected={subfolder.folderId === currentSubfolderId}
          onClick={() => setCurrentSubfolderId(subfolder.folderId)}
          withLink={false}
          key={subfolder.folderId}
          folder={subfolder}
        />
      ))}
    </SubfolderSlider>
  );
};
SelectableSubfolderSlider.displayName = 'SubfolderSliderSelector';

export default enhance(SelectableSubfolderSlider) as React.ComponentType<Props>;
